var map = {
	"./about/about.vue": [
		"ef46",
		"chunk-bdb964ca"
	],
	"./about/characteristic.vue": [
		"b455",
		"chunk-2f055fc1"
	],
	"./about/contact.vue": [
		"7625",
		"chunk-171da27c"
	],
	"./about/magazine.vue": [
		"fd62",
		"chunk-2a1736f9"
	],
	"./about/school.vue": [
		"9637",
		"chunk-77f66cfd"
	],
	"./about/services.vue": [
		"cef6",
		"chunk-71acd4fe"
	],
	"./course/course.vue": [
		"2720",
		"chunk-ddbf2d8a"
	],
	"./event/event.vue": [
		"e34b",
		"chunk-3a5c9882"
	],
	"./home/home.vue": [
		"77b8",
		"chunk-6f487568"
	],
	"./index.vue": [
		"1e4b"
	],
	"./news/news.vue": [
		"fd2f",
		"chunk-4dc18a2c"
	],
	"./strategy/strategy.vue": [
		"4fc6",
		"chunk-1362214e"
	],
	"./teaching/teaching.vue": [
		"c910",
		"chunk-e5d4722e"
	],
	"./ualifad/ualifad.vue": [
		"7a5d",
		"chunk-78d6a2e5"
	],
	"./ucapdp/ucapdp.vue": [
		"d93b",
		"chunk-3f0e090c"
	],
	"./uwe/uwe.vue": [
		"2405",
		"chunk-0f8eb192"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;